module.exports = __webpack_public_path__ + "img/multi_image09.c3f686e2.png";